import { useQuery } from '@tanstack/react-query';
import { fetchShipmentExceptionTypes } from '../data-provider/shipment-exception-type';

export const useGetShipmentExceptionTypes = () => {
  return useQuery({
    queryKey: ['shipment-exception-types'],
    queryFn: () => fetchShipmentExceptionTypes(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
